import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import Modal from "react-modal";
import ReactGA from 'react-ga';


Modal.setAppElement("#root");

ReactDOM.render(
  <App />,
  document.getElementById("root")
);

